// src/components/ui/DottedCorners.jsx
const DottedCorners = ({
  position = 'top-right',
  size = 40,
  opacity = 0.8,
}) => {
  const positionClasses = {
    'top-right': 'top-2 right-2',
    'top-left': 'top-2 left-2',
    'bottom-right': 'bottom-2 right-2',
    'bottom-left': 'bottom-2 left-2',
  }

  const maskStyles = {
    'top-right': 'radial-gradient(circle at top right, black 50%, transparent 85%)',
    'top-left': 'radial-gradient(circle at top left, black 50%, transparent 85%)',
    'bottom-right': 'radial-gradient(circle at bottom right, black 50%, transparent 85%)',
    'bottom-left': 'radial-gradient(circle at bottom left, black 50%, transparent 85%)',
  }

  return (
    <div
      className={`pointer-events-none absolute ${positionClasses[position]}
        bg-[radial-gradient(circle,_#9ca3af_1.5px,_transparent_1.5px)]
        dark:bg-[radial-gradient(circle,_#6b7280_1.5px,_transparent_1.5px)]
        bg-[size:10px_10px]`}
      style={{
        width: size,
        height: size,
        opacity,
        WebkitMaskImage: maskStyles[position],
        maskImage: maskStyles[position],
      }}
    />
  )
}

export default DottedCorners